import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

//datepicker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//middelware
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import Axios from "axios";
import moment from "moment";

//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";

import {
  create,  
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { ROUTES } from "../../../../utils/routes";
import Swal from "sweetalert2";
import { paths } from "../../../../utils/paths";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { validate } from "./validations";
import { ArchiveUploader } from "../../../../components/FileUploader/ArchiveUploader";

export const ManageSeminars = () => {
  const { SEMINARS } = paths;
  const { id } = useParams();
  const { deleteIt } = useDelete();

  let { isAdmin, userId } = useSelector(({ user }) => user);

  const history = useHistory();
  const [isCreate, setIsCreate] = useState(false);

  const [titleEs, setTitleEs] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleVa, setTitleVa] = useState("");
  const [abstractEs, setAbstractEs] = useState("");
  const [abstractEn, setAbstractEn] = useState("");
  const [abstractVa, setAbstractVa] = useState("");
  const [cvPonente, setCvPonente] = useState("");
  const [lugar, setLugar] = useState("");
  const [videoSeminario, setVideoSeminario] = useState("")
  const [nombrePonente, setNombrePonente] = useState("");
  const [institutoPonente, setInstitutoPonente] = useState("");
  const [creatorId, setCreatorId] = useState(null);
  const [fechaHora, setFechaHora] = useState(new Date());
  const [carrousel, setCarrousel] = useState();
  const [cartelNotaPrensa, setCartelNotaPrensa] = useState();
  const [adjunto, setAdjunto] = useState();
  const [notaDePrensa, setNotaDePrensa] = useState();
  const [interno, setInterno] = useState("");
  const [fotoPonente, setFotoPonente] = useState();

  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMountedRef.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? setIsCreate(true) : loadData();
    // loadStaticData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadData = async () => {
    try {
      let response = await getById(SEMINARS, id, source);
      isMountedRef.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  // prettier-ignore
  const buildObjToLoad = (response) => {
    const {
      titleEn,
      titleEs,
      titleVa,
      abstractEn,
      abstractEs,
      abstractVa,
      lugar,
      videoSeminario,
      cvPonente,
      institutoPonente,
      nombrePonente,
      interno,
      carrousel,
      cartelNotaPrensa,
      fotoPonente,
      adjunto,
      notaDePrensa,
      fechaHora,
    } = response;
    const {user: { id: userId }} = response;

	const dateWithOffset = new Date(fechaHora);
	const dateNoOffset = ( new Date( dateWithOffset.getTime() - dateWithOffset.getTimezoneOffset() * -60000 ));
    setTitleEn(titleEn);
    setTitleEs(titleEs);
	setTitleVa(titleVa);
   
    setCreatorId(userId);
    setCarrousel(carrousel);
    setCartelNotaPrensa(cartelNotaPrensa)
    setFotoPonente(fotoPonente)
    setAdjunto(adjunto)
    setNotaDePrensa(notaDePrensa)
    setFechaHora(dateNoOffset);
	setAbstractEs(abstractEs);
	setAbstractEn(abstractEn);
	setAbstractVa(abstractVa);
  setCvPonente(cvPonente)
  setInstitutoPonente(institutoPonente)
  setLugar(lugar)
  setVideoSeminario(videoSeminario)
  setNombrePonente(nombrePonente)
  setInterno(interno ? 1 : 0);


	if (isMountedRef.current) 
	setAllowedEdit(true);
  };

  const handleSubmit = () => {
    const seminars = build();
    //     const notValid = validate(seminars);
    //     if (notValid) {
    //       setMessage(notValid);
    //       setTimeout(() => setMessage(""), 4000);
    //       return;
    //     }
    let question = isCreate ? "crear un" : "editar este";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} seminario?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed &&
        handleConfirmation(
          seminars,
          carrousel,
          cartelNotaPrensa,
          fotoPonente,
          adjunto,
          notaDePrensa
        );
    });
  };

  const handleConfirmation = (
    seminars,
    carrousel,
    cartelNotaPrensa,
    fotoPonente,
    adjunto,
    notaDePrensa
  ) => {
    let createOrUpdate = isCreate
      ? create(SEMINARS, seminars, source)
      : update(SEMINARS, id, seminars, source);
    createOrUpdate
      .then(async ({ id }) => {
        Swal.fire({
          icon: "success",
          text: `Seminario ${isCreate ? "creado" : "editado"} correctamente.`,
        });
        if (typeof carrousel !== "string") {
          const formData = new FormData();
          formData.append("image", carrousel);
          await saveFile(SEMINARS, id, "carrousel", formData, source);
        }

        if (typeof cartelNotaPrensa !== "string") {
          const formData = new FormData();
          formData.append("image", cartelNotaPrensa);
          await saveFile(SEMINARS, id, "cartel-nota-prensa", formData, source);
        }
        if (typeof fotoPonente !== "string") {
          const formData = new FormData();
          formData.append("image", fotoPonente);
          await saveFile(SEMINARS, id, "foto-ponente", formData, source);
        }
        if (typeof adjunto !== "string") {
          const formData = new FormData();
          formData.append("document", adjunto);
          await saveFile(SEMINARS, id, "adjunto", formData, source);
        }
        if (typeof notaDePrensa !== "string") {
          const formData = new FormData();
          formData.append("document", notaDePrensa);
          await saveFile(SEMINARS, id, "nota-de-prensa", formData, source);
        }
        history.push(`${ROUTES.Seminars.all}/${id}`);
        setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const build = () => {
    return {
      userId: creatorId ? creatorId : userId,
      titleEs,
      titleEn,
      titleVa,
      fechaHora: moment(fechaHora).format("YYYY-MM-DD HH:mm"),
      interno: interno === 1 || interno === "1" ? true : false,
      abstractEs,
      abstractEn,
      abstractVa,
      lugar,
      videoSeminario,
      nombrePonente,
      institutoPonente,
      cvPonente,
    };
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Seminario
        </button>
      );
    }
    if ((!isCreate && userId === creatorId) || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() => deleteIt(SEMINARS, id, ROUTES.Seminars.all, source)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

  return (
    <div className="centerPage">
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div>
              <h3>Seminario </h3>
            </div>
            <div>{editDeleteButtons()}</div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Imágen para slider de la web</small>
            <FileUploader handleFile={setCarrousel} image={carrousel} />
          </div>
          <div className="col">
            <small>Imágen destacada del seminario</small>
            <FileUploader
              handleFile={setCartelNotaPrensa}
              image={cartelNotaPrensa}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Archivo adjunto</small>
            <ArchiveUploader handleFile={setAdjunto} archive={adjunto} />
          </div>
          <div className="col">
            <small>Nota de prensa</small>
            <ArchiveUploader
              handleFile={setNotaDePrensa}
              archive={notaDePrensa}
            />
          </div>
        </div>
        <div className="form-row ">
          <div className="col-6">
            <small>Interno?</small>
            <select
              className="form-control input"
              value={interno}
              onChange={({ target: { value } }) => {
                setInterno(value);
              }}
            >
              <option value={1}>Sí</option>
              <option value={0}>No</option>
            </select>
          </div>
          <div className="col">
            <small>*Fecha de publicación</small>
            <DatePicker
              className="form-control input"
              placeholderText="*Fecha y hora"
              selected={fechaHora}
              onChange={(fechaHora) => setFechaHora(fechaHora)}
              dateFormat="dd MMMM, yyyy HH:mm"
              showTimeSelect
              timeFormat="HH:mm"
              isClearable
              locale="es"
              dropdownMode="select"
              showMonthDropdown
              showYearDropdown
              adjustDateOnChange
            />
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>*Título español</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título español"
              value={titleEs}
              onChange={({ target: { value } }) => {
                setTitleEs(value);
              }}
            />
          </div>
          <div className="col">
            <small>*Título inglés</small>
            <input
              type="text"
              className="form-control"
              placeholder="Título inglés"
              value={titleEn}
              onChange={({ target: { value } }) => {
                setTitleEn(value);
              }}
            />
          </div>
          <div className="col">
            <small>*Título valenciano</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título valenciano"
              value={titleVa}
              onChange={({ target: { value } }) => {
                setTitleVa(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-4">
          {" "}
          <div className="col">
            <span>Lugar</span>
            <input
              type="text"
              className="form-control"
              placeholder="Lugar"
              value={lugar}
              onChange={({ target: { value } }) => setLugar(value)}
            />
          </div>{" "}
          <div className="col">
            <span>Link a video</span>
            <input
              type="text"
              className="form-control"
              placeholder="Link a video"
              value={videoSeminario}
              onChange={({ target: { value } }) => setVideoSeminario(value)}
            />
          </div>
        </div>
        <div className="form-row mt-4">
          <div className="col">
            <span>Foto Ponente</span>
            <FileUploader handleFile={setFotoPonente} image={fotoPonente} />
          </div>
          <div className="col">
            <span>Nombre ponente</span>
            <input
              type="text"
              className="form-control"
              placeholder="Nombre ponente"
              value={nombrePonente}
              onChange={({ target: { value } }) => setNombrePonente(value)}
            />
          </div>
          <div className="col">
            <span>Entidad procedencia</span>
            <input
              type="text"
              className="form-control"
              placeholder="Entidad procedencia"
              value={institutoPonente}
              onChange={({ target: { value } }) => setInstitutoPonente(value)}
            />
          </div>
          <div className="col">
            <span>Cv ponente</span>
            <input
              type="text"
              className="form-control"
              placeholder="Cv Ponente"
              value={cvPonente}
              onChange={({ target: { value } }) => setCvPonente(value)}
            />
          </div>
        </div>

        {(isCreate || allowedEdit) && (
          <>
            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en español</small>
                <CKEditor
                  initData={abstractEs}
                  config={editorConfig}
                  onChange={({ editor }) => {
                    setAbstractEs(editor.getData());
                  }}
                />
              </div>
            </div>

            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en inglés</small>
                <CKEditor
                  initData={abstractEn}
                  config={editorConfig}
                  onChange={({ editor }) => {
                    setAbstractEn(editor.getData());
                  }}
                />
              </div>
            </div>
            <div className="form-row mt-4">
              <div className="col">
                <small>*Texto en valenciano</small>
                <CKEditor
                  initData={abstractVa}
                  config={editorConfig}
                  onChange={({ editor }) => {
                    setAbstractVa(editor.getData());
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
